import type { SkillFrontmatterEntry } from "../../utils/skill-frontmatter";

const CORE_FRONTMATTER_KEYS = new Set([
  "name",
  "description",
  "license",
  "compatibility",
  "allowed-tools",
  "disable-model-invocation",
]);

export interface FrontmatterFormState {
  name: string;
  description: string;
  license: string;
  compatibility: string;
  allowedTools: string;
  manualOnlyInvocation: boolean;
  extraEntries: SkillFrontmatterEntry[];
}

const getEntryValue = (entries: SkillFrontmatterEntry[], key: string) =>
  entries.find(entry => entry.key === key)?.value ?? "";

export const buildFormState = (entries: SkillFrontmatterEntry[]): FrontmatterFormState => ({
  name: getEntryValue(entries, "name"),
  description: getEntryValue(entries, "description"),
  license: getEntryValue(entries, "license"),
  compatibility: getEntryValue(entries, "compatibility"),
  allowedTools: getEntryValue(entries, "allowed-tools"),
  manualOnlyInvocation: getEntryValue(entries, "disable-model-invocation").toLowerCase() === "true",
  extraEntries: entries.filter(entry => !CORE_FRONTMATTER_KEYS.has(entry.key)),
});
